<!-- 组织机构 -->
<template>
  <div class="organization">
    <div class="container">
      <!-- 面包屑 -->
      <div class="bread">
        <span class="bread-tab">组织机构</span>
      </div>
      <!-- 内容 -->
      <div class="show-box">
        <div class="show-search">
          <!-- 搜索 -->
          <div class="search-item">
            <span class="search-label">单位区域：</span>
            <el-cascader
              v-model="dataForm.area"
              :props="{ checkStrictly: true }"
              :options="arealist"
              clearable
              size="small"
              placeholder="请选择区域"
              @change="handleChange"
            ></el-cascader>
          </div>
          <div class="search-item">
            <span class="search-label">单位名称：</span>
            <el-input
              class="search-form"
              size="small"
              clearable
              v-model="dataForm.companyName"
              placeholder="请输入单位名称搜索"
            ></el-input>
          </div>
          <div class="search-item">
            <span class="search-label">单位类型：</span>
            <el-select
              class="search-form"
              size="mini"
              clearable
              v-model="dataForm.type"
              placeholder="请选择"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="地方团委" value="1"></el-option>
              <el-option label="学校团委" value="2"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="search-label">重点开展县（市、区）/重点组织学校：</span>
            <el-select
              class="search-form"
              size="mini"
              clearable
              v-model="dataForm.focusStatus"
              placeholder="请选择"
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="search-label">单位注册时间：</span>
            <div class="content-date-item">
              <el-date-picker
                v-model="startdate"
                type="date"
                placeholder="开始日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <span class="content-date-interval">至</span>
            <div class="content-date-item">
              <el-date-picker
                v-model="enddate"
                type="date"
                placeholder="结束日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </div>
          <div class="search-item">
            <span class="search-label">项目发布时间：</span>
            <div class="content-date-item">
              <el-date-picker
                v-model="project_start_time"
                type="date"
                placeholder="开始日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <span class="content-date-interval">至</span>
            <div class="content-date-item">
              <el-date-picker
                v-model="project_end_time"
                type="date"
                placeholder="结束日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
          </div>
          <div class="search-item">
            <el-button class="oper-button" type="primary" @click="setDataSort(1)">按时间排序<i class="el-icon-sort-up el-icon--right"></i></el-button>
            <el-button class="oper-button" type="primary" @click="setDataSort(2)">按行政区划排序<i class="el-icon-sort-up el-icon--right"></i></el-button>
            <el-button class="oper-button" size="small" @click="search()">搜索</el-button>
            <el-button class="oper-button" size="small" @click="reset()">重置</el-button>
            <el-button type="primary" class="oper-button" size="small" @click="exportFile()">导出</el-button>
          </div>
        </div>
        <!-- 列表 -->
        <div class="show-table">
          <el-table :data="dataList" stripe size="mini" style="width: 100%; ">
            <!-- <el-table-column prop="logo" label="单位logo" align="center">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.logo"
                  class="recommend-img"
                  :style="'background-image:url(' + scope.row.logo + ')'"
                ></div>
                <div v-else class="recommend-img">
                  <el-image style="height: 100%;background-color: #ccc;">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column prop="name" label="单位名称" align="center"></el-table-column>
            <el-table-column prop="province_name" label="单位区域" align="center">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.province_name || scope.row.city_name || scope.row.area_name"
                >{{ (scope.row.province_name?scope.row.province_name:'') + '&nbsp;' + (scope.row.city_name?scope.row.city_name:'') + '&nbsp;' + (scope.row.area_name?scope.row.area_name:'') }}</span>
                <span v-else>暂无单位区域</span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="单位类型" align="center">
              <template slot-scope="scope">
                {{ scope.row.type == 2 ? '学校团委' : '地方团委' }}
              </template>
            </el-table-column>
            <el-table-column prop="authorizer" label="单位联系人" align="center"></el-table-column>
            <!-- <el-table-column prop="authorizer_idcard" label="单位联系人身份证" align="center"></el-table-column> -->
            <!-- <el-table-column prop="business_nature" label="单位性质" align="center"></el-table-column> -->
            <el-table-column prop="focusStatus" label="重点开展县（市、区）/重点组织学校" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.focusStatus == '0'">否</span>
                <span v-else-if="scope.row.focusStatus == '1'">是</span>
                <span v-else>否</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="mobile" label="联系人手机号" align="center"></el-table-column> -->
            <!-- <el-table-column prop="activityNum" label="活动数" align="center"></el-table-column> -->
            <el-table-column prop="activityNum" label="项目数" align="center"></el-table-column>
            <el-table-column prop="postNum" label="岗位数" align="center"></el-table-column>
            <el-table-column prop="enrollNum" label="招募人数" align="center"></el-table-column>
            <el-table-column prop="joinNum" label="报名人数" align="center"></el-table-column>
            <el-table-column prop="passNum" label="录取人数" align="center"></el-table-column>
            <el-table-column prop="signinNum" label="报到人数" align="center"></el-table-column>
            <el-table-column prop="joinTeamNumber" align="center" min-width="100">
              <template slot="header">
                <el-tooltip class="item" effect="dark" content="不统计团队报备数据" placement="top">
                  <div style="cursor: pointer;"><span>报名团队数 <i class="el-icon-question" style="font-size: 13px;"></i></span></div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="enrollTeamNumber" align="center" min-width="100">
              <template slot="header">
                <el-tooltip class="item" effect="dark" content="不统计团队报备数据" placement="top">
                  <div style="cursor: pointer;"><span>录取团队数 <i class="el-icon-question" style="font-size: 13px;"></i></span></div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="applydate" label="申请时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="Details(scope.row)">查看详情</el-button>
                <el-button
                  v-if="scope.row.review_status == 1 && scope.row.type == 1"
                  type="text"
                  size="mini"
                  @click="setFocusStatus(scope.row)"
                >{{ scope.row.focusStatus == '1'?'取消重点开展县（市、区）':scope.row.focusStatus == '0'?'设置为重点开展县（市、区）':'' }}</el-button>
                <el-button
                  v-if="scope.row.review_status == 1 && scope.row.type == 2"
                  type="text"
                  size="mini"
                  @click="setFocusStatus(scope.row)"
                >{{ scope.row.focusStatus == '1'?'取消设为重点组织学校':scope.row.focusStatus == '0'?'设为重点组织学校':'' }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="page-wrap">
            <div class="muiltiOpiton"></div>
            <el-pagination
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
              :current-page="listPage.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="listPage.size"
              size="small"
              :total="records"
              layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 详情弹窗 -->
    <el-dialog
      :title="'查看详情'"
      :close-on-click-modal="false"
      :visible.sync="orgVisible"
      :append-to-body="true"
      :modal="true"
      width="70%"
    >
      <div class="orgDetails" ref="shareDom">
        <el-divider content-position="left">单位详情</el-divider>
        <div class="details-item-box">
          <div class="details-tdlist">
            <span class="details-title">单位ID：</span>
            <span class="details-content">{{ detailsData.id || '无'}}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">单位LOGO：</span>
            <span class="details-content-logo">
              <div
                v-if="detailsData.logo"
                class="details-recommend-img"
                :style="'background-image:url(' + detailsData.logo + ')'"
              ></div>
              <div v-else class="details-recommend-img">
                <!-- <el-image style="height: 100%;background-color: #ccc;">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image> -->
              </div>
            </span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">单位名称：</span>
            <span class="details-content">{{ detailsData.name || '无'}}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">单位类型：</span>
            <span class="details-content">{{ detailsData.type == 2 ? '学校团委' : '地方团委' }}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">单位区域：</span>
            <span
              class="details-content"
              v-if="detailsData.province_name || detailsData.city_name || detailsData.area_name"
            >{{ (detailsData.province_name?detailsData.province_name:'') + '&nbsp;' + (detailsData.city_name?detailsData.city_name:'') + '&nbsp;' + (detailsData.area_name?detailsData.area_name:'') }}</span>
            <span class="details-content" v-else>暂无区域</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">单位地址：</span>
            <span class="details-content">{{ detailsData.address || '无'}}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">单位联系人：</span>
            <span class="details-content">{{ detailsData.authorizer || '无'}}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">单位联系人身份证：</span>
            <span class="details-content">{{ detailsData.authorizer_idcard || '无'}}</span>
          </div>
          <!-- <div class="details-tdlist">
            <span class="details-title">单位性质：</span>
            <span class="details-content">{{ detailsData.business_nature || '无'}}</span>
          </div> -->
          <div class="details-tdlist">
            <span class="details-title">联系人手机号：</span>
            <span class="details-content">{{ detailsData.mobile || '无'}}</span>
          </div>
          <div class="details-tdlist">
            <span class="details-title">申请时间：</span>
            <span class="details-content">{{ detailsData.createdate || '无'}}</span>
          </div>
        </div>
      </div>
      <div class="details-tdlist details-sureBtn">
        <el-button type="primary" size="small" @click="detailsSure()">确定</el-button>
        <el-button type="primary" size="small" @click="clickGeneratePicture()">下载详情图片</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import { Input, Button, Select, Option, DatePicker, Table, TableColumn, Pagination, Cascader, Dialog, Divider, Tooltip } from 'element-ui'
import {downloadExport, UrlUpdateParams} from '@/util/utils'
export default {
  components: {
    'el-input': Input,
    'el-button': Button,
    'el-select': Select,
    'el-option': Option,
    'el-date-picker': DatePicker,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-pagination': Pagination,
    // 'el-image': Image,
    'el-cascader': Cascader,
    'el-dialog': Dialog,
    'el-divider': Divider,
    'el-tooltip': Tooltip
  },
  data () {
    return {
      detailsData: {},
      orgVisible: false,
      listPage: {
        page: 1,
        size: 20
      },
      records: 0,
      dataForm: {
        sort: 1,
        area: '',
        date: '',
        projectDate: '',
        companyName: '',
        province_id: '',
        city_id: '',
        area_id: '',
        focusStatus: '',
        type: ''
      },
      dataList: [],
      arealist: [], // 省市区存储数据
      startdate: null,
      enddate: null,
      project_start_time: null,
      project_end_time: null
    }
  },
  created () {
    // 获取省市区三级联动数据
    this.getAreainfo((res) => {
      this.arealist = res
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    setDataSort (val) {
      this.dataForm.sort = val
      this.listPage.page = 1
      this.init()
    },
    init (type) {
      if (type && type === 'search') {
        this.listPage.page = 1
      }
      let data = {
        province_id: this.dataForm.province_id || '',
        city_id: this.dataForm.city_id || '',
        area_id: this.dataForm.area_id || '',
        startdate: this.startdate ? `${this.startdate} 00:00:00` : '',
        enddate: this.enddate ? `${this.enddate} 23:59:59` : '',
        project_start_time: this.project_start_time ? `${this.project_start_time} 00:00:00` : '',
        project_end_time: this.project_end_time ? `${this.project_end_time} 23:59:59` : '',
        name: this.dataForm.companyName || '',
        focusStatus: this.dataForm.focusStatus || '',
        pagesize: this.listPage.size,
        page: this.listPage.page,
        sort: this.dataForm.sort,
        type: this.dataForm.type
      }
      this.$http({
        method: 'post',
        url: '/data/enterprise/list',
        params: data
      }).then(res => {
        if (res.rows) {
          this.dataList = res.rows
          this.records = res.records
        }
      }).catch(error => {
        console.log(error)
        return false
      })
    },
    getBas64 (url, outputFormat = 'image/png') {
      return new Promise(function (resolve, reject) {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let img = new Image()
        img.crossOrigin = 'Anonymous' // 重点！设置image对象可跨域请求
        img.onload = function () {
          canvas.height = img.height
          canvas.width = img.width
          ctx.drawImage(img, 0, 0)
          let dataURL = canvas.toDataURL(outputFormat)
          canvas = null
          resolve(dataURL)
        }
        img.src = url + '?t=' + new Date().valueOf() // 防止oss的缓存问题
      })
    },
    // 设置重点开展县
    setFocusStatus (obj) {
      if (obj.id) {
        let msgs = ''
        let modelMsgs = ''
        let focusStatus = ''
        if (obj.focusStatus === '1' || obj.focusStatus === 1) {
          msgs = +obj.type === 1 ? '取消重点开展县（市、区）成功' : '取消设为重点组织学校成功'
          modelMsgs = +obj.type === 1 ? '是否确定取消' + obj.name + '为重点开展县（市、区）' : '是否确定取消' + obj.name + '为重点组织学校'
          focusStatus = 0
        } else if (obj.focusStatus === '0' || obj.focusStatus === 0) {
          msgs = +obj.type === 1 ? '设置为重点开展县（市、区）成功' : '设为重点组织学校成功'
          modelMsgs = +obj.type === 1 ? '是否确定设置' + obj.name + '为重点开展县（市、区）' : '是否确定设置' + obj.name + '为重点组织学校'
          focusStatus = 1
        }
        this.$confirm(modelMsgs, '信息提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (focusStatus !== '') {
            this.$http({
              method: 'post',
              url: '/data/set/focus',
              params: {
                id: obj.id,
                focusStatus: focusStatus
              }
            }).then(res => {
              if (res.code === 100 || res.code === '100') {
                this.$message.success(msgs)
                this.init()
              } else {
                this.$message.error(res.msg || res.result.msg)
              }
            }).catch(error => {
              console.log(error)
              return false
            })
          }
        }).catch(() => {
          this.$message.info('已取消设置')
        })
      }
    },
    // 搜索
    search () {
      this.init('search')
    },
    // 重置
    reset () {
      Object.assign(this.$data.dataForm, this.$options.data().dataForm)
      this.startdate = null
      this.enddate = null
      this.project_start_time = null
      this.project_end_time = null
      this.init('search')
    },
    // 修改列表展示条数时调用
    sizeChangeHandle (val) {
      this.listPage.size = val
      this.init('search')
    },
    // 页码改变时触发
    currentChangeHandle (val) {
      this.listPage.page = val
      this.init()
    },
    // 查看详情
    Details (row) {
      let _this = this
      this.$http({
        method: 'post',
        url: '/data/enterprise/detail',
        params: {
          id: row.id
        }
      }).then(res => {
        if (res.code === 100) {
          _this.getBas64(res.result[0].logo).then(result => {
            _this.$set(res.result[0], 'logo', result)
            _this.detailsData = res.result[0] || ''
            _this.orgVisible = true
          })
        }
      }).catch(error => {
        console.log(error)
        return false
      })
    },
    // 关闭详情
    detailsSure () {
      this.orgVisible = false
      this.detailsData = {}
    },
    // 省市区三级联动选择事件
    handleChange (item) {
      this.dataForm.province_id = item[0] || ''
      this.dataForm.city_id = item[1] || ''
      this.dataForm.area_id = item[2] || ''
    },
    // 导出
    exportFile () {
      let params = {
        province_id: this.dataForm.province_id || '',
        city_id: this.dataForm.city_id || '',
        area_id: this.dataForm.area_id || '',
        startdate: this.startdate ? `${this.startdate} 00:00:00` : '',
        enddate: this.enddate ? `${this.enddate} 23:59:59` : '',
        project_start_time: this.project_start_time ? `${this.project_start_time} 00:00:00` : '',
        project_end_time: this.project_end_time ? `${this.project_end_time} 23:59:59` : '',
        name: this.dataForm.companyName || '',
        focusStatus: this.dataForm.focusStatus || '',
        sort: this.dataForm.sort,
        type: this.dataForm.type
      }
      let downURL = UrlUpdateParams('/api/data/export/enterprise/list', params)
      const loading = this.$loading({
        lock: true,
        text: '处理中 ...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.35)'
      })
      downloadExport(downURL, loading)
    },
    // 保存图片
    saveFileM (Url, filename) {
      var blob = new Blob([''], { type: 'application/octet-stream' })
      var url = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = Url
      a.download = filename || this.detailsData.name + '.jpg'
      var e = document.createEvent('MouseEvents')
      e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
      URL.revokeObjectURL(url)
    },
    // 生成图片
    clickGeneratePicture () {
      this.$alert('图片已经开始下载，请稍候..', {
        type: 'success',
        confirmButtonText: '确定'
      })
      html2canvas(this.$refs.shareDom).then(canvas => {
        // 转成图片，生成图片地址
        this.imgUrl = canvas.toDataURL('image/png', 1) // 可将 canvas 转为 base64 格式
        this.saveFileM(this.imgUrl.replace('image/jpeg', 'image/octet-stream'))
      })
    }
  }
}
</script>
<style src='./organization.scss' lang="scss" scoped></style>
<style lang="scss" scoped>
.content-date-item {
  display: inline-block;

  >>> .el-input--suffix {
    .el-input__inner {
      padding-left: 32px;
    }
  }
}
.content-date-interval {
  padding: 0 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/organization/organization.vue